import React, { useState } from 'react';
import './composition.css'; // Import the CSS file
import { GoCopy } from "react-icons/go";
import { HiOutlineExternalLink } from "react-icons/hi";
import { AiOutlineLike, AiOutlineDislike } from "react-icons/ai";
import { FaStarOfLife } from "react-icons/fa";

const Composition: React.FC = () => {
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);

  const handleImageClick = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  return (
    <div className="container">
      <div className="loanContainer">
        <div className='composition-title'>
            Below you will find the Loan Composition for Citizens National Bank
        </div>
        <img
          src="loan.png"
          alt="Below you will find the Loan Composition for Citizens National Bank"
          className="loan"
          onClick={handleImageClick} // Handle image click to open modal
        />
      </div>
      <div className="footer">
        <div className='icon-left'>
          <GoCopy className="icon" title="Copy" />
          <HiOutlineExternalLink className="icon" title="Redirect" />
          <AiOutlineLike className="icon" title="Like" />
          <AiOutlineDislike className="icon" title="Dislike" />
        </div>
        <div className='icon-right display'>
          <GoCopy className="iconleft" title="Copy" />
          <HiOutlineExternalLink className="iconleft" title="Redirect" />
          <FaStarOfLife className="iconleft" title="Like" />
        </div>
      </div>

      {/* Modal Implementation */}
      {isModalOpen && (
        <div className="modal">
          <span className="close" onClick={handleCloseModal}>&times;</span>
          <div className="modal-content">
            <img
              src="loan.png"
              alt="Below you will find the Loan Composition for Citizens National Bank"
              className="modal-image"
            />
             <div className='icon-right modelicon-right'>
                <GoCopy className="iconleft" title="Copy" />
                <HiOutlineExternalLink className="iconleft" title="Redirect" />
                <FaStarOfLife className="iconleft" title="Like" />
            </div>
          </div>
         
        </div>
      )}
    </div>
  );
};

export default Composition;
